// Add to your LanguageContext translations file
// This goes into your t.* translation object

export const trialEndTranslations = {
  de: {
    trialEnd: {
      title: 'Deine Testphase ist vorbei',
      subtitle: 'Möchtest du xchannels.ai weiter nutzen?',
      cta: 'Buche ein Paket und starten wir richtig durch.',
      monthly: 'Monatlich',
      yearly: 'Jährlich',
      savings: 'Sparen Sie 20%',
      perMonth: 'Monat',
      orderNow: 'Jetzt kostenpflichtig bestellen',
      bookCall: 'Jetzt Call buchen',
      featured: 'Beliebteste Wahl',
      customDesc: 'Maßgeschneidert für Deine Bedürfnisse',
      discussion: 'Möchtest du noch etwas mit uns besprechen?',
      
      // Billing form
      billingData: 'Rechnungsdaten',
      step1Of3: 'Schritt 1 von 3: Unternehmensdaten',
      step2Of3: 'Schritt 2 von 3: Kontaktdaten',
      step3Of3: 'Schritt 3 von 3: Adresse',
      
      // Form fields
      companyName: 'Firmenname',
      companyType: 'Unternehmensform',
      soleTrader: 'Einzelunternehmer',
      limitedCompany: 'Kapitalgesellschaft',
      taxNumber: 'Steuernummer',
      vatId: 'Umsatzsteuer-ID / Steuernummer',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      street: 'Straße & Hausnummer',
      city: 'Stadt',
      zip: 'PLZ',
      country: 'Land',
      
      // Buttons & Navigation
      back: 'Zurück',
      next: 'Weiter',
      getInvoice: 'Rechnung erhalten',
      summary: 'Zusammenfassung',
      plan: 'Plan',
      price: 'Preis',
      
      // Success
      thankyou: 'Vielen Dank!',
      successMessage: 'Deine Rechnungsdaten wurden erfolgreich übermittelt. Du erhältst in Kürze eine E-Mail mit deiner Rechnung und den Zugangsdaten.',
      whatNext: 'Was kommt als nächstes?',
      confirmation: 'Zahlungsbestätigung per E-Mail',
      creditsAvailable: 'Neue Credits sind sofort verfügbar',
      fullAccess: 'Weiterhin uneingeschränkter Zugang zu allen Features',
      backToApp: 'Zurück zur App',
    }
  },
  en: {
    trialEnd: {
      title: 'Your trial period has ended',
      subtitle: 'Do you want to continue using xchannels.ai?',
      cta: 'Book a plan and let\'s get started.',
      monthly: 'Monthly',
      yearly: 'Yearly',
      savings: 'Save 20%',
      perMonth: 'month',
      orderNow: 'Order now',
      bookCall: 'Book a call',
      featured: 'Most popular',
      customDesc: 'Tailored to your needs',
      discussion: 'Want to discuss something with us?',
      
      // Billing form
      billingData: 'Billing information',
      step1Of3: 'Step 1 of 3: Company data',
      step2Of3: 'Step 2 of 3: Contact data',
      step3Of3: 'Step 3 of 3: Address',
      
      // Form fields
      companyName: 'Company name',
      companyType: 'Company type',
      soleTrader: 'Sole trader',
      limitedCompany: 'Limited company',
      taxNumber: 'Tax number',
      vatId: 'VAT ID / Tax number',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      street: 'Street & house number',
      city: 'City',
      zip: 'Postal code',
      country: 'Country',
      
      // Buttons & Navigation
      back: 'Back',
      next: 'Next',
      getInvoice: 'Get invoice',
      summary: 'Summary',
      plan: 'Plan',
      price: 'Price',
      
      // Success
      thankyou: 'Thank you!',
      successMessage: 'Your billing information has been successfully submitted. You will receive an email shortly with your invoice and access details.',
      whatNext: 'What comes next?',
      confirmation: 'Payment confirmation via email',
      creditsAvailable: 'New credits available immediately',
      fullAccess: 'Continued unrestricted access to all features',
      backToApp: 'Back to app',
    }
  }
};
